<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Расчетный счет в банке получателя</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="value" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const userData = inject('userData');

const value = computed(() => {
    return userData['rs_b_pol'];
});

</script>
